import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { customerService } from '@services/api/customerService';
import { getCaseStatusLabel, getCaseStatusColor, getCasePriorityLabel, getCasePriorityColor } from '@/types/case';
import '../CustomerTabs.css';

interface CasesTabProps {
  customerId: string;
}

export const CasesTab = ({ customerId }: CasesTabProps) => {
  const [cases, setCases] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCases();
  }, [customerId]);

  const loadCases = async () => {
    const result = await customerService.getCustomerCases(customerId);
    if (result.success && result.data) {
      setCases(result.data);
    }
    setLoading(false);
  };

  if (loading) return <div>Loading cases...</div>;

  return (
    <div className="tab-content-wrapper">
      <div className="info-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--spacing-lg)' }}>
          <h3 className="info-card-title">📋 Support Cases</h3>
          <Link to={`/cases/new?customer=${customerId}`} className="btn btn-primary btn-small">
            + Create Case
          </Link>
        </div>
        
        {cases.length === 0 ? (
          <p className="text-secondary">No cases found</p>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Case ID</th>
                  <th>Type</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Assigned To</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {cases.map((c) => (
                  <tr key={c.id}>
                    <td className="customer-id">#{c.id.slice(0, 8)}</td>
                    <td className="text-capitalize">{c.case_type.replace(/_/g, ' ')}</td>
                    <td>
                      <span className={`priority-badge priority-${getCasePriorityColor(c.priority)}`}>
                        {getCasePriorityLabel(c.priority)}
                      </span>
                    </td>
                    <td>
                      <span className={`status-badge status-${getCaseStatusColor(c.status)}`}>
                        {getCaseStatusLabel(c.status)}
                      </span>
                    </td>
                    <td className="text-small">{new Date(c.created_at).toLocaleDateString()}</td>
                    <td className="text-small">
                      {c.assigned_to_staff ? 
                        `${c.assigned_to_staff.first_name} ${c.assigned_to_staff.last_name}` : 
                        'Unassigned'}
                    </td>
                    <td>
                      <Link to={`/cases/${c.id}`} className="btn btn-ghost btn-small">
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

